/**
 * The available sub views.
 */
enum SubViewTypes
{
    PowerClient = 'PowerClient',
    PowerProxy = 'PowerProxy',
}

export default SubViewTypes;
